/**
 * Blueprint · April 2026
 * The pre-seed blueprint deck, kept as it was sent: its recipients hold
 * these passwords, and the PDF/PPTX below are its record. Its slides are
 * shared with later editions — see `../slides` before changing one.
 */

import type { DeckEdition } from '@components/press/pitch-deck/pitch-deck.types';
import { DECK_EXPORTS } from '@components/press/pitch-deck/export-pdf';
import {
  VisionSlide,
  ProblemSlide,
  MarketSlide,
  WhyNowSlide,
  PathToVictorySlide,
  TeamSlide,
  AppendixOverviewSlide,
  CoreHypothesisSlide,
  LessonsLearnedSlide,
  StrategyCallsSlide,
  GrowthSlide,
  ProductGrowthSlide,
  MarketDetailSlide,
  CompetitiveDimensionsSlide,
  InvisibleLaborSlide,
  ToolingGapSlide,
  TechStackGapSlide,
  CognitiveLoadSlide,
  DelegationGapSlide,
  AffluenceParadoxSlide,
  UserLoveSlide,
} from '@components/press/pitch-deck/slides';

export const BLUEPRINT_APRIL_2026: DeckEdition = {
  meta: { title: 'The Home CEO', subtitle: 'Blueprint', date: 'April 2026' },
  passwords: {
    myceo: '',              // internal — no watermark
    june: 'June',
    demo: 'Demo',
    jcarollo: 'J Carollo',
    ayates: 'A Yates',
    sagaventures: 'Saga Ventures',
    thomsonisawesome: 'Thomson',
    // Add competition-specific passwords here, e.g.:
    // 'techstars2026': 'Techstars 2026',
  },
  label: 'Blueprint: The Home CEO',
  tocTitle: 'PreSeed Deck',
  downloads: {
    pdf: { href: `${DECK_EXPORTS}/HomeCEO-Preseed-Deck.pdf`, filename: 'HomeCEO-Preseed-Deck.pdf' },
    pptx: { href: `${DECK_EXPORTS}/HomeCEO-Preseed-Deck.pptx`, filename: 'HomeCEO-Preseed-Deck.pptx' },
  },
  slides: [
    { id: 'vision', title: 'Vision', category: 'main', component: VisionSlide },
    { id: 'problem', title: 'Problem', category: 'main', component: ProblemSlide },
    { id: 'market', title: 'Market', category: 'main', component: MarketSlide },
    { id: 'why-now', title: 'Why Now', category: 'main', component: WhyNowSlide },
    { id: 'path-to-victory', title: 'Path to Victory', category: 'main', component: PathToVictorySlide },
    { id: 'team', title: 'Team', category: 'main', component: TeamSlide },
    { id: 'appendix-overview', title: 'Appendix', category: 'appendix', component: AppendixOverviewSlide },
    { id: 'core-hypothesis', title: 'Core Hypothesis', category: 'appendix', component: CoreHypothesisSlide },
    { id: 'lessons-learned', title: 'Lessons Learned', category: 'appendix', component: LessonsLearnedSlide },
    { id: 'strategy-calls', title: 'June’s Hunches', category: 'appendix', component: StrategyCallsSlide },
    { id: 'growth', title: 'User Growth', category: 'appendix', component: GrowthSlide },
    { id: 'product-growth', title: 'Product Growth', category: 'appendix', component: ProductGrowthSlide },
    { id: 'market-detail', title: 'Market Detail', category: 'appendix', component: MarketDetailSlide },
    { id: 'competitive-dimensions', title: 'Competitive Dimensions', category: 'appendix', component: CompetitiveDimensionsSlide },
    { id: 'invisible-labor', title: 'Invisible Labor', category: 'appendix', component: InvisibleLaborSlide },
    { id: 'tooling-gap', title: 'Tooling Gap', category: 'appendix', component: ToolingGapSlide },
    { id: 'tech-stack-gap', title: 'Tech Stack Gap', category: 'appendix', component: TechStackGapSlide },
    { id: 'cognitive-load', title: 'Cognitive Load', category: 'appendix', component: CognitiveLoadSlide },
    { id: 'delegation-gap', title: 'Delegation Gap', category: 'appendix', component: DelegationGapSlide },
    { id: 'affluence-paradox', title: 'Affluence Paradox', category: 'appendix', component: AffluenceParadoxSlide },
    { id: 'user-love', title: 'User Love', category: 'appendix', component: UserLoveSlide },
  ],
};
